import API from "../http-common";

const getAllPackages = () => {
	return API.get("/auctions/package");
};

const getOnePackage = (id) => {
	return API.get(`/auctions/package/${id}`);
};

const findPackageByUuid = (uuid) => {
	return API.get(`/auctions/package/uuid/${uuid}`);
};

const createPackage = (data) => {
	return API.post("/auctions/package", data);
};

const updatePackage = (id, data) => {
	return API.put(`/auctions/package/${id}`, data);
};

const getOnePackageItem = (id) => {
	return API.get(`/auctions/item/${id}`);
};

const updatePackageItem = (id, data) => {
	return API.put(`/auctions/item/${id}`, data);
};

const updatePackageBidder = (id, data) => {
	return API.put(`/auctions/bidder/${id}`, data);
};

const getTopAutoBidsPerUser = (id) => {
	return API.get(`/auctions/top-auto-bids/${id}`);
};

const updatePackageStatus = (id, status_id, updatedBy) => {
	return API.put(`/auctions/package/${id}/status`, { status_id, updatedBy });
};

const auctionservice = {
	getAllPackages,
	getOnePackage,
	findPackageByUuid,
	createPackage,
	updatePackage,
	getOnePackageItem,
	updatePackageItem,
	updatePackageBidder,
	getTopAutoBidsPerUser,
	updatePackageStatus,
};

export default auctionservice;
